import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleOperador } from "../hooks/roles/ProtectedRoleOperador";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const Tareas = React.lazy(() => import("../screean/task/tareas"));
export function tareasOperador() {
  return (
    <Route
      path="/tareas-operador"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleOperador>
              <Tareas />
            </ProtectedRoleOperador>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
